import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    "Content-type": "application/json"
  }
});

// ✅ Interceptor : Ajouter le token Bearer à chaque requête
api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Token Bearer ajouté:', token.substring(0, 30) + '...');
  } else {
    console.warn('⚠️ Pas de token trouvé');
  }
  
  return config;
});

//Interceptor : Gérer les erreurs 401
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.error('❌ Token invalide ou expiré');
      localStorage.removeItem('access_token');
      window.location.href = '/';  
    }
    return Promise.reject(error);
  }
);

export default api;